import React, { Component } from 'react';
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import './PaperReferencer.css'

const getReferences = () => {
  return [
      /* 1*/`Kumar, R. S., Mawman, D., Sankaran, D., Melling, C., O'Driscoll, M., Freeman, S. M., & Lloyd, S. K. (2016). Cochlear implantation in early deafened, late implanted adults: Do they benefit?. Cochlear implants international, 17(sup1), 22-25.`,
      /* 2*/`Castiglione, A., Benatti, A., Girasoli, L., Caserta, E., Montino, S., Pagliaro, M., ... & Martini, A. (2015). Cochlear implantation outcomes in older adults. Hearing, Balance and Communication, 13(2), 86-88.`,
      /* 3*/`Lenarz, M., Sönmez, H., Joseph, G., Büchner, A., & Lenarz, T. (2012). Long-term performance of cochlear implants in postlingually deafened adults. Otolaryngology--Head and Neck Surgery, 147(1), 112-118.`,
      /* 4*/`Severity of Hearing Loss Categories for Outcomes Prediction Models`,
      /* 5*/`Prototype English Word Score Outcomes Model`,
      /* 6*/`Postoperative Distributions of SSQ S3Q10 S3Q15 Questions`,
      /* 7*/`CAM5717 Retrospective Study`,
      /* 8*/`CLTD5685 – CIP – Clinical Evaluation of the Cochlear Nucleus CI532 Cochlear Implant in Adults`,
      /* 9*/`CLTD5595 Outcome Prediction Clinical Investigation Protocol 3`,
      /*10*/`CEL5277 IROS CLINICAL INVESTIGATION REPORT`,
      /*11*/`Holder, J. T., Dwyer, N. C., & Gifford, R. H. (2020). Duration of processor use per day is significantly correlated with speech recognition abilities in adults with cochlear implants. Otology & neurotology: official publication of the American Otological Society, American Neurotology Society [and] European Academy of Otology and Neurotology, 41(2), e227.`,
      /*12*/`Holder, J. T., & Gifford, R. H. (2021). Effect of increased daily cochlear implant use on auditory perception in adults. Journal of Speech, Language, and Hearing Research, 64(10), 4044-4055.`,
      /*13*/`Busch, T., Vanpoucke, F., & van Wieringen, A. (2017). Auditory environment across the life span of cochlear implant users: Insights from data logging. Journal of Speech, Language, and Hearing Research, 60(5), 1362-1377.`,
      /*14*/`Bento, R. F., Brito Neto, R., Castilho, A. M., Gómez, V. G., Giorgi, S. B., & Guedes, M. C. (2004). Auditory results with multichannel cochlear implant in patients submitted to cochlear implant surgery at Medical School, Hospital das Clínicas, University of Sao Paulo. Braz J Otorhinolaryngol, 70, 632-7.`,
      /*15*/`Zhao, F., Stephens, S. D. G., Sim, S. W., & Meredith, R. (1997). The use of qualitative questionnaires in patients having and being considered for cochlear implants. Clinical Otolaryngology & Allied Sciences, 22(3), 254-259.`,
      /*16*/`Wick, C. C., Kallogjeri, D., McJunkin, J. L., Durakovic, N., Holden, L. K., Herzog, J. A., ... & CI532 Study Group. (2020). Hearing and quality-of-life outcomes after cochlear implantation in adult hearing aid users 65 years or older: a secondary analysis of a nonrandomized clinical trial. JAMA Otolaryngology–Head & Neck Surgery, 146(10), 925-932.`,
      /*17*/`Porps, S. L., Bennett, D. M., Gilden, J., Ravelo, K., Buck, B., Reinhart, P., & Hong, R. S. (2023). Effects of an evidence-based model for cochlear implant aftercare delivery on clinical efficiency and patient outcomes. Cochlear Implants International, 1-10.`,
      /*18*/`Reed, C. M., & Delhorne, L. A. (2005). Reception of environmental sounds through cochlear implants. Ear and hearing, 26(1), 48-6`,
      /*19*/`Di Nardo, W., Anzivino, R., Giannantonio, S., Schinaia, L., & Paludetti, G. (2014). The effects of cochlear implantation on quality of life in the elderly. European Archives of Oto-Rhino-Laryngology, 271, 65-7`,
      /*20*/`Gatehouse, S., & Noble, W. (2004). The speech, spatial and qualities of hearing scale (SSQ). International journal of audiology, 43(2), 85-99.` 
  ];
}
const { v4: uuidv4 } = require('uuid');

class PaperReferencer extends Component {
    getTooltip(refs){
      const itemList = refs.map((item, index) => 
        <li key={index} className=''> {getReferences().at(item)}</li>
      );
      return (
        <ul className='referencer-tooltip-items white100 caption1 font-normal1'>
          {itemList}
        </ul>
      );      
    }
    getText(refs){
      return `[${refs.map(index => index+1).join(',')}]`;
    }
    render () {
      let refIndex = this.props.refIndex instanceof Array ? this.props.refIndex : [this.props.refIndex];
      let arrayIndex = refIndex.map(num => num-1);

      let refText = this.props?.displayingText ?? this.getText(arrayIndex);
      const guid = uuidv4();
      
      return (
        <div style={{display:"inline-block", marginLeft:"1px"}}>
          <span data-tooltip-id={guid} className={"referencer-text " + this.props?.className} onClick={() => this.props?.onClick()}> 
              {refText}
          </span>
          <Tooltip id={guid} place="bottom" className='referencer-tooltip'>
            {this.getTooltip(arrayIndex)}
          </Tooltip>             
        </div>
      );
    }
  }

export default PaperReferencer;